/**
 * Internal-only UI switch for Pactline AI, and the only one: every AI control
 * across the app stays hidden until this returns true. That is the floating
 * chat button and its panel, the AI tab and "Ask AI" action on a contract, an
 * obligation and a receivable, obligation insights, starter wording in the
 * editors, the AI admin pages and the AI settings card.
 *
 * Receivables AI used to have a switch of its own ("isEmeisAI"). It no longer
 * does anything: receivables follow this switch like everything else. The backend enforces its own switches and
 * permissions regardless; this only decides whether the UI is shown.
 *
 * Off by default. Turn it on from the browser console and reload:
 *
 *   localStorage.setItem("enableEmeisAI", "true")
 *
 * and off again with localStorage.removeItem("enableEmeisAI").
 */
export const EMEIS_AI_FLAG_KEY = "enableEmeisAI";

export function isEmeisAIEnabled(): boolean {
  try {
    return localStorage.getItem(EMEIS_AI_FLAG_KEY) === "true";
  } catch {
    return false;
  }
}
